import { api } from './axios'
import type { Curso } from '@/types'

export async function getAllCursos() {
  const response = await api.get<Curso[]>('/cursos/all', {
    params: { ignoreSiteMetadata: true },
  })
  return response.data
}

export async function getCursosByUf(uf: string) {
  const response = await api.get<{ cursos: number[] }>('/cursos/by-uf', { params: { uf } })
  return response.data.cursos
}
